import templateUrl from "emun.order/modify-order/modified-orders-list-grid.htm";

export default () => ({ templateUrl });